
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class FiltersBar extends Vue {
  @Prop(Function) sort!: Function;

  sortBy: string = "Ordenar por";
  sortOptions: any = ["Más recientes", "Más compatibles", "Más vistas"];
}
